import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { fetchRolePermissions } from '../services/apiService';

// Function to get the role from the token
const getRoleFromToken = () => {
  const token = localStorage.getItem('authToken');
  if (!token) return null;
  try {
    const decodedToken = JSON.parse(atob(token.split('.')[1]));
    const role = decodedToken?.role;
    return role ? role.toLowerCase().replace(/\s+/g, '') : null;
  } catch {
    return null;
  }
};

// Function to check if the user is authenticated
const isAuthenticated = () => {
  const token = localStorage.getItem('authToken');
  return !!token; // Check if token exists
};

const PrivateRoute = ({ children }) => {
   
  const [rolePermissions, setRolePermissions] = useState(null); // State to store permissions
  const [loading, setLoading] = useState(true); // State to manage loading status
  const [error, setError] = useState(null); // State to manage errors
 
  const userRole = getRoleFromToken(); // Get role from token

  useEffect(() => {
    // Load permissions only if there's a valid user role
    if (userRole) {
      const loadPermissions = async () => {
        try {
          const data = await fetchRolePermissions(userRole);  // Get role permissions from the API
          
          const permissionsMap = data.reduce((acc, { role, permissionPath }) => {
            if (!acc[role]) {
              acc[role] = [];
            }
            acc[role].push(permissionPath); // Group permissions by role
            return acc;
          }, {});
          setRolePermissions(permissionsMap); // Update the state with fetched permissions
        } catch (error) {
          setError(error); // If error occurs, update state with error
        } finally {
          setLoading(false); // Set loading to false once done
        }
      };

      loadPermissions();
    } else {
      setLoading(false); // If no userRole, set loading false immediately
    }
  }, [userRole]);
 
  const currentPath = window.location.pathname;

  // If user is not authenticated, redirect to login page
  if (!isAuthenticated()) {
    return <Navigate to="/login" />;
  }

  // If loading or error occurs, render loading state or error message
  if (loading) {
    return <div>Loading...</div>;
  }

  if (error) {
    return <div>Error loading permissions</div>;
  }

  // If userRole is undefined, redirect to unauthorized page
  if (!userRole) {
    return <Navigate to="/unauthorized" />;
  }
  
   
  // Check if the role has permission to access the current path
  //const isAuthorized = rolePermissions[userRole]?.includes(currentPath);

    // Dynamic route check for candidate details
    const isAuthorized = rolePermissions[userRole]?.some(permission => {
      // Check for dynamic permission, e.g. candidate details
      // Match exact path or handle dynamic IDs in paths like /candidate-details/:id
      if (currentPath.includes('candidate-details')) {
        return permission.includes('candidate-details'); // Check if user has permission for any candidate details path
      }
      if (currentPath.includes('evaluation')) {
        return permission.includes('evaluation'); // Check if user has permission for any candidate details path
      }
      return permission === currentPath; // Exact match for other paths
    });

  // Return the children if authorized, otherwise redirect to unauthorized page
  return isAuthorized ? children : <Navigate to="/unauthorized" />;
};

export default PrivateRoute;
